angular.module('callX').controller('ViewCampaignDetailsCtrl', ['$scope', 'CampaignsService', '$stateParams', 'toaster', 'UserService', '$state', 'DateService', 'DataService', function($scope, CampaignsService, $stateParams, toaster, UserService, $state, DateService, DataService) {


    $scope.campaignId = $stateParams.campaignId;
    $scope.campaign = {};
    $scope.countryCodes = DataService.getCountryCodes();
    $scope.textIVRDetails = {};
    $scope.textIVRDetails.country = "1";
    $scope.topData = {};
    $scope.chartOptions = {};
    $scope.leadAccessStatus = 'N/A';
    $scope.leadApiInfo = {};
    $scope.loadingDetailsContent = false;
    $scope.currentUserData = UserService.getCurrentUserData();
    $scope.publisherId = $scope.currentUserData.id;
    $scope.orderParam = '';

    var fetchPublisherCampaignData = function(){
        CampaignsService.getPublisherCampaignData($scope.campaignId, $scope.currentUserData.id)
            .success(function (response) {
                $scope.campaign = response.data.campaign;
            });
    };

    var setGraphViewData = function(data){
        $scope.topData = data.data;
        var graphData = data.data.graph_data;
        var list_items_array = [];
        var list_item = { data: [], label: '', points: { show: true, radius: 3}, stack: false, lines: { show: true,  fill: 1, fillColor: { colors: [{ opacity: 0.1 }, { opacity: 0.1}] } } };
        list_item.data = graphData;
        list_item.label = 'Earnings';
        list_items_array.push(list_item);
        $scope.chartOptions.list = list_items_array;
//        console.log("$scope.chartOptions.list",$scope.chartOptions.list);
    };

    var fetchGraphData = function(activeDate, dateRangeValue){
        var callbacks = {
            success: function(data) {
                setGraphViewData(data)
            },
            failure: function(data) {

            }
        };
        CampaignsService.getGraphData($scope.campaignId, activeDate, 'earnings', dateRangeValue, $scope.plotBy(activeDate), callbacks);
    };

    var getLeadsAccessStatus = function(){
        $scope.loadingDetailsContent = true;
        $scope.currentUserData = UserService.getCurrentUserData();
        var callbacks = {
            success: function(data) {
//                console.log("data",data);
                $scope.leadAccessStatus = data.data.status;
                $scope.leadApiInfo = data.data;
                $scope.errorCodesData = data.data.error_codes;
                $scope.sucessResponse = data.data.sussess_response_object;
                $scope.errorResponse = data.data.error_response_object;
                $scope.loadingDetailsContent = false;
            },
            failure: function(data) {
                $scope.loadingDetailsContent = false;
            }
        };
        CampaignsService.fetchLeadsAccessStatus($scope.campaignId, $scope.currentUserData.id, callbacks);
    };

    var getLeadsAccessStatusUnsecured = function(){
        $scope.loadingDetailsContent = true;
        $scope.currentUserData = UserService.getCurrentUserData();
        var callbacks = {
            success: function(data) {
               // console.log("this is data",data);
                $scope.leadAccessStatus = data.data.status;
                $scope.leadApiInfo = data.data;
                $scope.errorCodesData = data.data.error_codes;
                $scope.sucessResponse = data.data.sussess_response_object;
                $scope.errorResponse = data.data.error_response_object;
                $scope.loadingDetailsContent = false;
            },
            failure: function(data) {
                $scope.loadingDetailsContent = false;
            }
        };
        CampaignsService.fetchLeadsAccessStatusUnsecured($scope.campaignId, $scope.currentUserData.id, callbacks);
    };


    var fetchPromoTableData = function(activeDate, dateRangeValue){
        $scope.currentUserData = UserService.getCurrentUserData();
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                $scope.tableContentLoading = false;
                $scope.promoNumbers = data.data;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;

            }
        };
        CampaignsService.getPromoTableData($scope.campaignId, $scope.currentUserData.id, activeDate, dateRangeValue, callbacks);
    };

    var checkPublisherCampaignApplied = function(){
        CampaignsService.checkPublisherCampaignApplied($scope.campaignId, $scope.currentUserData.id)
            .success(function(response) {
                $scope.applied = true;
                $scope.publisherCampaign = response.data;
            });
    };

    $scope.fetchStatisticsData = function(activeDate, dateRangeValue){
        fetchGraphData(activeDate, dateRangeValue);
        fetchPromoTableData(activeDate, dateRangeValue);
        $scope.activeDate = activeDate;
        $scope.dateRangeValue = dateRangeValue;
    };

    var statsInit = function () {
        $scope.promoNumbers = [];
        $scope.chartOptions = {};
        var TempDateObj = DateService.getDateObj();
        $scope.activeDate = TempDateObj.activeDate;
        $scope.dateRangeValue = TempDateObj.dateRangeValue;
        if(TempDateObj.timezone!=undefined){
            $scope.fetchStatisticsData(TempDateObj.activeDate, TempDateObj.dateRangeValue);
        }
    };

    var campaignDetailsInit = function () {

        switch($state.current.name) {
            case 'app.campaigns.view-statistics':
                statsInit();
                fetchPublisherCampaignData();
                checkPublisherCampaignApplied();
                $scope.orderParam = 'total_calls';
                break;
            case 'app.campaigns.view-details':
                fetchPublisherCampaignData();
                checkPublisherCampaignApplied();
                break;
            case 'app.campaigns.campaign-leads':
                fetchPublisherCampaignData();
                checkPublisherCampaignApplied();
                getLeadsAccessStatus();
                $scope.orderParam = 'required';
                break;
            case 'app.campaigns.campaign-leads-unsecure':
                fetchPublisherCampaignData();
                checkPublisherCampaignApplied();
                getLeadsAccessStatusUnsecured();
                $scope.orderParam = 'required';
                break;  
            default:
                statsInit();
                fetchPublisherCampaignData();
                checkPublisherCampaignApplied();
        }
    };

    if($scope.currentUserData.id!=undefined){
//        console.log("$scope.currentUserData",$scope.currentUserData);
        campaignDetailsInit();
    }

    $scope.textIVR = function(){
        $scope.textIVRDetails.campaign_id = $scope.campaignId;
        $scope.textIVRDetails.from = $scope.textIVRDetails.country + $scope.textIVRDetails.from_number;
//        console.log("$scope.textIVRDetails",$scope.textIVRDetails);

        if ($scope.textIVRDetails.country == undefined) {
            toaster.pop('error', 'Error',  'Country code is required.', 2000);
        }

        else if ($scope.textIVRDetails.from_number == undefined) {
            toaster.pop('error', 'Error', 'Phone Number is required', 2000);
        }

        if ($scope.textIVRDetails.country != undefined && $scope.textIVRDetails.from_number!= undefined) {
            var callbacks = {
                success: function (data) {
                    if(data.status == "error") {
                        toaster.pop('error', 'Error Occurred', data.data);
                    } else {
                        toaster.pop('success', 'Success', 'Call is now in progress', 2000);
                        $scope.showIVRForm = 0;
                        $scope.textIVRDetails.from_number = '';
                    }
                },
                failure: function (data) {
                    $scope.showIVRForm = 0;
                }
            };
            CampaignsService.testIVR($scope.textIVRDetails, callbacks);
        }
    };

    $scope.addPromoNumber = function(){
        if ($scope.promoNumberDescription == undefined) {
            toaster.pop('error', 'Error',  'Promo Number Description is required.', 2000);
        }

       else {
            $scope.currentUserData = UserService.getCurrentUserData();
            $scope.addingPromoNumber = true;
            var callbacks = {
                success: function (data) {
//                    console.log("Data",data);
                    $scope.showAddPromoForm = 0;
                    $scope.addingPromoNumber = false;
                    toaster.pop('success', 'Success', 'Promo Number Added', 2000);
                    statsInit();
                    $scope.promoNumberDescription = '';
                },
                failure: function (data) {
                    $scope.showAddPromoForm = 0;
                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                    $scope.addingPromoNumber = false;
                    $scope.promoNumberDescription = '';
                }
            };
            CampaignsService.addPromoNumberWithDescription($scope.campaignId, {'description': $scope.promoNumberDescription,'promo_number_type':'inbound','user_id': $scope.currentUserData.id}, callbacks);
        }
    };

    $scope.savePromoNumber = function(index, promoId, description){
        if (description == undefined) {
            toaster.pop('error', 'Error',  'Promo Number Description is required.', 2000);
        }

        else {
            $scope.promoNumbers[index].isSavingDescription = true;
            var callbacks = {
                success: function (data) {
//                    console.log("Data",data);
                    $scope.promoNumbers[index].editContainer = false;
                    $scope.promoNumbers[index].isSavingDescription = false;
                    toaster.pop('success', 'Success', 'Promo Number Description Saved', 2000);
                    statsInit();
                },
                failure: function (data) {
                    $scope.promoNumbers[index].editContainer = false;
                    $scope.promoNumbers[index].isSavingDescription = false;
                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                }
            };
            CampaignsService.savePromoNumberDescription(promoId, {'description': description,'promo_number_type':'inbound'}, callbacks);
        }
    };

    $scope.reverse = false;
    $scope.order = function(orderParam) {
//        console.log("Here!", orderParam);
        $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : true;
        $scope.orderParam = orderParam;
    };

    $scope.deletePromoNumber = function(index, promoId, description){
            $scope.promoNumbers[index].isSavingDescription = true;
            var callbacks = {
                success: function (data) {
//                    console.log("Data",data);
                    $scope.promoNumbers[index].deleteContainer = false;
                    $scope.promoNumbers[index].isSavingDescription = false;
                    toaster.pop('success', 'Success', 'Promo Number Successfully Deleted', 2000);
                    statsInit();
                },
                failure: function (data) {
                    $scope.promoNumbers[index].deleteContainer = false;
                    $scope.promoNumbers[index].isSavingDescription = false;
                    toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                }
            };
            CampaignsService.removePromoNumber(promoId, callbacks);
    };

    $scope.$on('currentUserUpdate', function(event, userData) {
        $scope.currentUserData = userData;
        campaignDetailsInit();
    });

    $scope.$on('dateObjUpdate', function(event, dateObj) {
        $scope.fetchStatisticsData(dateObj.activeDate, dateObj.dateRangeValue);
    });

    $scope.requestLeadsAccess = function () {
//        console.log("Here");
        var callbacks = {
            success: function (data) {
                toaster.pop('success', 'Success', 'Lead Access Requested', 2000);
                campaignDetailsInit();
            },
            failure: function (data) {
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
        CampaignsService.requestAccessToLeads($scope.campaignId, $scope.currentUserData.id, callbacks);
    }

}]);